import React from 'react';

import ProfileContext from 'components/Profile/ProfileContext';
import MantelAndScrapComponent from './MantelAndScrapComponent';

export function MantelAndScrapContainer() {
  return (
    <ProfileContext.Consumer>
      {({ editable }) => (
        <MantelAndScrapComponent
          editable={editable}
        />
      )}
    </ProfileContext.Consumer>
  );
}

MantelAndScrapContainer.displayName = 'MantelAndScrapContainer';

export default MantelAndScrapContainer;